function popup(state = { qrCodePop: '', openProductPop: false, openDialog: false, openRejectServicePopup: { show: false }, openReferServicePopup: { show: false }, reminderPop: { show: false }, bottomNotifications: [] }
    , action) {
    switch (action.type) {
        case "SET_QRPOPUP_STATUS":
            return {
                ...state,
                qrCodePop: action.data
            };
        case "SET_PRODUCT_POPUP":
            return {
                ...state,
                openProductPop: action.data
            }
        case "SET_DIALOG":
            return {
                ...state,
                openDialog: action.data
            }
            case "SET_TOAST_DATA":
                return{
                    ...state,
                    openDialog:action.data
                }
        case "SET_REJECTSERVICE_POPUP":
            return {
                ...state,
                openRejectServicePopup: action.data
            }
        case "SET_REFERSERVICE_POPUP":
            return {
                ...state,
                openReferServicePopup: action.data
            }
        case "REMINDER_POP":
            return {
                ...state,
                reminderPop: action.data
            }
        case "SET_NOTIFICATION_DATA":
            return {
                ...state,
                bottomNotifications: action.data

            }
        default:
            return state;
    }
}
export default popup;